// Canonical list of system roles.
//
// These MUST stay in sync with the `role` ENUM on the `users` table:
//   ENUM('account_receivable','account_supervisor','dispatch','admin')
// The database rejects any value outside this list, so the Add/Edit User
// dropdown only offers these four.
export const ROLE_OPTIONS = [
  { value: 'admin', label: 'Admin' },
  { value: 'dispatch', label: 'Dispatch' },
  { value: 'account_supervisor', label: 'Account Supervisor' },
  { value: 'account_receivable', label: 'Account Receivable' },
];

export const ROLE_VALUES = ROLE_OPTIONS.map((r) => r.value);

export const DEFAULT_ROLE = 'dispatch';

// Turn a raw role value into a human friendly label.
export function formatRole(role) {
  if (!role) return '-';
  const found = ROLE_OPTIONS.find((r) => r.value === role);
  if (found) return found.label;
  // Fallback for any unexpected value (e.g. legacy rows)
  return role.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase());
}
